export default {
  en: {
    title: 'User Guide',
    subtitle: 'Everything you need to know about working with us',
    international_trade: 'International Trade',
    stats: {
      countries: 'Countries',
      clients: 'Clients',
      years: 'Years',
      satisfaction: 'Satisfaction'
    },
    partnership: {
      title: 'Partnership Information',
      section1: {
        title: 'Sales Agent or Dealers Welcomed',
        text: 'We welcome sales agents and dealers from around the world to join our distribution network.'
      },
      section2: {
        title: 'End User Support',
        text: 'Our experienced project engineers provide comprehensive support throughout the entire process, from initial consultation to after-sales service.',
        original: 'For the End User, Fuhai Have the excellent Project Engineer can help you to solve all your questions during the pre sale, manufacture, delivery, installation and after service work.'
      },
      section3: {
        title: 'Trading Company Protection',
        text: 'We respect our business partnerships and ensure that your profits and client relationships are protected.',
        original: 'For the Trading Company or Third Party, Fuhai will help you to protect your Profit, Will not Loot your Client, also project your Client Secret.'
      },
      section4: {
        title: 'Marketing Collaboration',
        text: 'We are open to collaborative marketing efforts with third parties to promote our products through various channels.',
        original: 'Fuhai Welcome to corporate with the Thirdy Party to made the Company or Product Promotions in Newspapers, Exhibitions, Bill board, Magazines etc.'
      }
    },
    service: {
      title: 'Service & Support',
      step1: {
        title: 'Global Support',
        text: 'While we don\'t have physical offices in all countries, we provide remote support and can dispatch engineers when needed.'
      },
      step2: {
        title: 'Quality Assurance',
        text: 'Our products are built with high-quality materials and components to ensure reliability and minimal maintenance requirements.',
        original: 'For this Cranes/hoist, it just a Machine tools, Nearly all the machine is metal structure, It not easy failure, In order to avoid the future troubles, All Davol Machines Spare Parts adopt the Top Brand and Quality, our Aid is to made Davol Cranes Maintenance-free.'
      },
      step3: {
        title: 'Global Presence',
        text: 'With a global presence in over 80 countries, our machines have proven their reliability and performance worldwide.'
      },
      step4: {
        title: 'Installation Training',
        text: 'We provide training to your installation and maintenance teams during the setup process to ensure they can handle routine maintenance and minor issues.'
      },
      step5: {
        title: 'Local Support Network',
        text: 'Local maintenance support is often available, and we can help connect you with resources in your area. For major issues, we\'ll send our engineers to resolve them.'
      }
    },
    certifications: {
      title: 'International Certifications'
    },
    warranty: {
      title: 'Warranty & Service',
      question: 'Q: If services is free of charge if there is some problem arise after sales?',
      answer: 'Fuhai will take responsibility for Fuhai Machines during the whole working Life, Supply the full spare parts and after service for all its working life.'
    },
    footer: {
      cta: 'Ready to Start International Business?',
      contact_btn: 'Contact Us Now',
      payment_title: 'Accepted Payment Methods',
      credit_cards: 'Credit Cards',
      international: 'International',
      asian_markets: 'Asian Markets'
    }
  },
  zh: {
    title: '用户指南',
    subtitle: '与我们合作的所有必要信息',
    international_trade: '国际贸易',
    stats: {
      countries: '国家',
      clients: '客户',
      years: '年限',
      satisfaction: '满意度'
    },
    partnership: {
      title: '合作伙伴信息',
      section1: {
        title: '欢迎销售代理商',
        text: '我们欢迎来自世界各地的销售代理商和经销商加入我们的分销网络。'
      },
      section2: {
        title: '终端用户支持',
        text: '我们经验丰富的项目工程师在整个过程中提供全面支持，从初步咨询到售后服务。',
        original: '对于终端用户，福海拥有优秀的项目工程师，可以帮助您解决售前、制造、交付、安装和售后服务工作中的所有问题。'
      },
      section3: {
        title: '贸易公司保护',
        text: '我们尊重业务合作伙伴关系，确保您的利润和客户关系得到保护。',
        original: '对于贸易公司或第三方，福海将帮助您保护您的利润，不会抢夺您的客户，同时保护您的客户秘密。'
      },
      section4: {
        title: '营销合作',
        text: '我们愿意与第三方进行营销合作，通过各种渠道推广我们的产品。',
        original: '福海欢迎与第三方合作，在报纸、展览、广告牌、杂志等进行公司或产品宣传。'
      }
    },
    service: {
      title: '服务与支持',
      step1: {
        title: '全球支持',
        text: '虽然我们不在所有国家都设有办事处，但我们提供远程支持，并可在需要时派遣工程师。'
      },
      step2: {
        title: '质量保证',
        text: '我们的产品采用高质量材料和组件制造，确保可靠性和最低维护要求。',
        original: '对于这些起重机/吊具，它只是机械工具，几乎所有机器都是金属结构，不易故障，为了避免未来的麻烦，所有达沃尔机械备件都采用顶级品牌和质量，我们的目标是使达沃尔起重机免维护。'
      },
      step3: {
        title: '全球业务',
        text: '在全球80多个国家的业务中，我们的机器已经证明了其可靠性和性能。'
      },
      step4: {
        title: '安装培训',
        text: '我们在安装过程中为您的安装和维护团队提供培训，确保他们能够处理日常维护和小问题。'
      },
      step5: {
        title: '本地支持网络',
        text: '当地通常有维护支持，我们可以帮助您联系当地资源。对于重大问题，我们会派遣工程师解决。'
      }
    },
    certifications: {
      title: '国际认证'
    },
    warranty: {
      title: '保修与服务',
      question: '问：如果销售后出现问题，服务是否免费？',
      answer: '福海将在整个工作寿命期间对福海机器负责，提供全部备件和售后服务。'
    },
    footer: {
      cta: '准备开始国际业务？',
      contact_btn: '立即联系我们',
      payment_title: '接受的支付方式',
      credit_cards: '信用卡',
      international: '国际支付',
      asian_markets: '亚洲市场'
    }
  }
}
